import {
    INTERVIEW_SET_TYPES,
} from '../../constants/interview.constant.js';
import {VIEW_INFO} from "../../../ams/constants/view.constants.js";

(function () {
    "use strict";

    function InterviewSettingsForm(scope, viewService, hUser, InterviewDataService, $modal, isManageAvailability, $filter, source, brandServices, userPermissions, Upload) {
        var self = this;
        var formName = "interview-settings-form";
        var _protected = BaseForm.call(self, formName, scope);
        var _emitter = JarEventEmitter.call(self);

        var locationFromServer;
        var hasInterviews;
        self.data = {};
        self.interviewersList = [];
        self.messageTemplates = [];
        self.data.interviewers = [];
        self.data.locations = [];
        self.data.candidates = [];
        self.data.job = {};
        self.data.selected_candidates = {};
        self.data.attachments = []
        self.isManageAvailability = isManageAvailability;
        self.data.interviewCategory = 'IN_PERSON';
        self.TEMPLATE_TYPES = INTERVIEW_SET_TYPES;
        self.uploadingAttachment = false;
        let messagesByTab = {};
        const allowedAttachmentTypes = [
            'application/pdf',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/jpg'
        ];

        self.handleAttachmentUpload = async ($files) => {
            if (!$files || !$files.length) return;
            const file = $files[0];
            if (!allowedAttachmentTypes.includes(file.type)) {
                Utils.hAlert({
                    title: $filter("translate")("Upload error"),
                    text: $filter("translate")("Only PDF, Word, and image files are allowed."),
                });
                return;
            } else if (Utils.getFileSizeMB(file) > 10) {
                Utils.hAlert({
                    title: $filter("translate")("Upload error"),
                    text: $filter("translate")("File size exceeds 10MB limit."),
                });
                return;
            }

            try {
                self.uploadingAttachment = true;
                const fileExtension = file.name.split('.').pop() || '';
                const fileName = file.name.split('.').slice(0, -1).join('.').replace(/\s+/g, '_');

                const presignedUrlResponse = await InterviewV2API.getAttachmentPresignedUrl({
                    type: 'INTERVIEW_INVITE',
                    brandId: self.data.brandId,
                    fileExtension: fileExtension,
                    fileName: fileName,
                });
                const {href, s3_path} = presignedUrlResponse;
                Upload.http({
                    url: href,
                    method: 'PUT',
                    headers: {'Content-Type': ''},
                    'Content-Type': '',
                    data: file,
                }).success(async () => {
                    self.data.attachments.push({
                        file_path: s3_path,
                        file_name: file.name,
                        mime_type: file.type,
                        file_href: await this.getFileHref(presignedUrlResponse.s3_path),
                    });
                    self.uploadingAttachment = false;
                }).error(() => {
                    HNotifications.show({
                        title: $filter("translate")("Upload error"),
                        desc: $filter("translate")("Could not upload file"),
                        type: "danger"
                    });
                });
            } catch (error) {
                console.error('Error fetching presigned URL:', error);
            }
        }

        self.getFileHref = async (s3Path) => {
            const response = await InterviewV2API.getAttachmentPresignedUrl({
                type: 'INTERVIEW_INVITE',
                brandId: self.data.brandId,
                s3Path: s3Path,
            });
            return response.href;
        }

        self.removeAttachment = function (index) {
            self.data.attachments.splice(index, 1);
        };

        self.setActiveTab = async (type) => {
            if (self.data.interviewCategory) {
                messagesByTab[self.data.interviewCategory] = self.data.message;
            }

            self.data.interviewCategory = type;

            if (messagesByTab[type]) {
                self.data.message = messagesByTab[type];
            } else {
                setDefaultMessage();
                self.data.message = defaultMessage;
            }

            self.getMessageTemplates();
            await getSmartFields();
            delete self.validator.validation.message;
        }

        const checkInterviewServiceAndPermissions = async (brandId) => {
            let promises = [
                brandServices.check(brandServices.SERVICES.INTERVIEW_V2, brandId),
                userPermissions.getBrandPolicy(brandId),
            ]

            let [isInterviewV2ServiceEnabled, policyParser, ] = await Promise.all(promises);
            return {
                isInterviewV2ServiceEnabled: isInterviewV2ServiceEnabled,
                canManageInterviewTemplates: policyParser.has(userPermissions.PERMISSIONS.MANAGE_QUESTION_BANK_VIDEO_INTERVIEW_FIELDS)
            }
        }

        self.load = async (formData, setInfo) => {
            if (setInfo.attachments) {
                self.data.attachments = setInfo.attachments.map(attachment => ({
                    file_path: attachment.file_path,
                    file_name: attachment.file_name,
                    mime_type: attachment.mime_type,
                    file_href: attachment.file_href
                }));
            }
            self.openDayEnabled = scope.openDayEnabled;
            self.data.brandId = formData.brandId;
            self.data.selected_candidates = formData.selectedCandidates || [];
            self.data.job = formData.job;
            self.data.locations = formData.locations || [];
            self.interviewType = formData.interviewType;
            self.isPhoneInterview = self.interviewType === self.TEMPLATE_TYPES.PHONE;
            self.data.interviewCategory = setInfo.category || 'IN_PERSON';
            self.data.video_link = setInfo.video_interview_link;
            self.data.positionCode = self.data?.job?.Position?.code;
            const {isInterviewV2ServiceEnabled, canManageInterviewTemplates} = await checkInterviewServiceAndPermissions(self.data.brandId);
            self.isInterviewV2ServiceEnabled = isInterviewV2ServiceEnabled;
            self.canManageInterviewTemplates = canManageInterviewTemplates;
            if (self.data?.job?.id && !formData.useSelectedCandidates) {
                InterviewV2API.getFeasibleCandidates(self.data.brandId, self.data.job.id, self.interviewType).then(function (applications) {
                    for (var i = 0; i < applications.length; i++) {
                        var candidate = applications[i].user;
                        candidate.application_id = applications[i].id;
                        candidate.name = candidate.first_name + ' ' + candidate.last_name;
                        self.data.candidates.push(candidate);
                    }
                    scope.$digest();
                });
            } else if (formData.useSelectedCandidates) {
                self.data.candidates = angular.copy(formData.smartMatchCandidates)
            }
            await getSmartFields();
            setDefaultMessage();
            // Get default message from server meta data or from front end default template
            self.data.message = setInfo.id ? setInfo?.message?.message : defaultMessage;
            self.data.interview_overlap = (setInfo && setInfo.allow_overlap) || false;
            self.interviewOverlapChanged();

            if (setInfo.location) {
                if (self.data.locations && self.data.locations.length) {
                    var inLocations = _.findWhere(self.data.locations, {google_place_id: setInfo.location.google_place_id})
                    if (!inLocations) {
                        self.data.selected_location = _.findWhere(self.data.locations, {id: "CUSTOM"});
                        self.data.custom_location = {};
                        self.data.custom_location.label = setInfo.location.formatted_address;
                        self.data.custom_location.value = setInfo.location;
                    } else {
                        self.data.selected_location = inLocations;
                    }
                }
                else {
                    self.data.selected_location = _.findWhere(self.data.locations, {id: "CUSTOM"});
                    self.data.custom_location = {};
                    self.data.custom_location.label = setInfo.location.formatted_address;
                    self.data.custom_location.value = setInfo.location;
                }
            }
            else {
                if (self.data.job && self.data.job.JobLocation && self.data.job.JobLocation[0]) {
                    self.data.selected_location = _.findWhere(self.data.locations, {google_place_id: self.data.job.JobLocation && self.data.job.JobLocation[0].google_place_id});
                } else if (formData.selectedLocation) {
                    self.data.selected_location = _.findWhere(self.data.locations, {google_place_id: formData.selectedLocation.google_place_id});
                }
            }

            locationFromServer = formData.selectedLocation;
            hasInterviews = formData.hasInterviews;

            if (self.isInterviewV2ServiceEnabled) {

                if (setInfo && setInfo.applications) {

                    var selectedCandidatesIds = _.pluck(self.data.selected_candidates, 'application_id');

                    for (var app in setInfo.applications) {

                        var candidateApp = setInfo.applications[app];

                        if (selectedCandidatesIds.indexOf(candidateApp.application_id) < 0) {

                            var selectedCandidateFromApp = {
                                application_id: candidateApp.application_id,
                                bucket: 'Interview',
                                id: candidateApp.user_id,
                                interview_status: {
                                    application_id: candidateApp.application_id,
                                    interview_set: {
                                        type: "INVITE",
                                        id: candidateApp.id
                                    },
                                    interview_set_slot: candidateApp.interview_set_slot,
                                    status: candidateApp.status
                                },
                                location_id: 'all',
                                name: candidateApp.user.first_name + ' ' + candidateApp.user.last_name,
                                profileImageUUID: candidateApp.user.profile_image.uuid
                            };

                            self.data.selected_candidates.push(selectedCandidateFromApp);
                        }
                    }
                }

                if (setInfo) {
                    self.data.interviewers = setInfo.interviewers || [];
                }

                self.getMessageTemplates();
                self.getBrandInterviewers();
            }
            scope.$digest();
        };

        self.save = function () {
            var deferred = $q.defer();
            if (self.validator.validate()) {
                deferred.resolve(self.data);
            }
            else {
                deferred.reject();
            }

            return deferred.promise;
        };

        self.validator.validateCustom = function (field, optionsField, rule, showError) {

            var name = field.attr("name");
            var value = self.validator.getFieldValue(field);

            switch (rule.name) {
                case "location_change_confirm":
                    if (self.data.selected_location && locationFromServer) {
                        if (self.data.selected_location?.id != locationFromServer.id && hasInterviews) {
                            self.showLocationWarning = true;
                        }
                        else {
                            self.showLocationWarning = false;
                        }
                    }
                    else {
                        self.showLocationWarning = false;
                    }

                    break;

                case "required-if":

                    if (self.data.selected_location && self.data.selected_location.id == 'CUSTOM' && !value) {
                        self.validator.validation[name].errors[rule.name] = true;
                        return false;
                    }

                    break;

                case "required-fields":
                    self.messingRequiredFields = [];
                    for (let i in self.allSmartFields) {
                        let field = self.allSmartFields[i];
                        if (field.necessity === "REQUIRED" && value.indexOf(field.code) === -1) {
                            self.messingRequiredFields.push(field);
                        }
                    }
                    if (self.messingRequiredFields.length) {
                        return false;
                    }
                    break;
            }

            return true;
        };

        scope.onSelectNewInterviewer = function (event) {

            var addedInterviewer = event.added.value;

            if (addedInterviewer && addedInterviewer.id) {

                self.data.interviewers = self.data.interviewers.concat(addedInterviewer);

                var interviewerIndex = _.findIndex(self.interviewersList, function (interviewer) {
                    return interviewer.id === addedInterviewer.id
                });

                // work around to fit with the select2 and remove the selection option
                setTimeout(function () {
                    self.selectedInterviewersToAdd = {};
                    scope.$digest();
                }, 1);

                self.interviewersList.splice(interviewerIndex, 1);
                scope.onInterviewersChanged({ val: self.data.interviewers });
            }
        };

        self.removeInterviewerAtIndex = function (index) {
            self.interviewersList.push(self.data.interviewers.splice(index, 1)[0]);
            scope.onInterviewersChanged({ val: self.data.interviewers });
            var inputElement = $('.' + formName).find('input[name="number_of_interviewers"]');
            inputElement.trigger('change');
        };

        self.getBrandInterviewers = function () {
            JobAPI.getJobsEmployers(self.data.brandId, self.data.job.Position.code, null, self.data.job.post_type)
                .then(function (response) {
                    if (response.users && response.users.length) {
                        self.interviewersList = response.users.map(function(emp) {
                            return {
                                id: emp.id,
                                name: Utils.capitalize(emp.first_name) + ' ' + Utils.capitalize(emp.last_name),
                                user: emp
                            };
                        });

                        self.interviewersList = _.sortBy(self.interviewersList, 'name');
                    }

                    for (var i in self.data.interviewers) {
                        self.data.interviewers[i]['name'] = self.data.interviewers[i]['user']['first_name'] + ' ' + self.data.interviewers[i]['user']['last_name'];

                        var interviewerIndex = _.findIndex(self.interviewersList, function (interviewer) {
                            return interviewer.user.id == self.data.interviewers[i].user.id;
                        });

                        if (interviewerIndex > -1) {
                            self.interviewersList.splice(interviewerIndex, 1);
                        }
                    }

                    scope.onInterviewersChanged({ val: self.data.interviewers });
                    scope.$digest();
                });
        };

        self.onSelectMessageTemplate = function () {
            if (self.data.selected_template && self.data.selected_template.message) {
                self.data.message = self.data.selected_template.message;
                self.data.attachments = [];
                if (self.data.selected_template.attachments &&
                    self.data.selected_template.attachments.length > 0) {

                    self.data.attachments = self.data.selected_template.attachments.map(attachment => ({
                        file_path: attachment.file_path,
                        file_name: attachment.file_name,
                        mime_type: attachment.mime_type,
                        file_href: attachment.file_href
                    }));
                }
            }
            else {
                setDefaultMessage();
                self.data.message = defaultMessage;
                self.data.attachments = [];
            }
        };

        /**
         * Call the manage templates modal and send necessary data
         */
        self.manageMessages = (interviewCategory) => {
            $modal({
                controller: 'ManageLaneTemplatesModal',
                templateUrl: '../modules/ams/modals/manage_lane_templates/manage_lane_templates_modal.html',
                show: true,
                backdrop: 'static',
                resolve: {
                    modalData: function () {
                        return {
                            brandId: self.data.brandId,
                            interviewTemplate: true,
                            interviewType: self.interviewType,
                            interviewCategory: interviewCategory,
                            positionCode: self.data.positionCode
                        };
                    },
                    onClose: function () {
                        return function (messageTemplates) {
                            self.messageTemplates = messageTemplates.map(function(template) {
                                return {
                                    title: template.name,
                                    id: template.id,
                                    message: template.message,
                                    mode: template.mode,
                                    attachments: template.attachments || [],
                                }
                            });
                        }
                    }
                }
            });
        };

        self.getMessageTemplates = function () {
            InterviewV2API.getBrandMessageTemplates(self.data.brandId, self.interviewType, self.data.interviewCategory, self.data.positionCode)
                .then(function (response) {
                    if (response.message_templates && response.message_templates.length) {
                        self.messageTemplates = response.message_templates;
                    } else {
                        self.messageTemplates = [];
                    }

                    scope.$digest();
                });
        };

        self.interviewOverlapChanged = function () {
            _emitter.trigger('INTERVIEW_OVERLAP_CHANGED', self.data['interview_overlap']);
        };

        let getSmartFields = async () => {
            self.loadingSmartFields = true;
            const params = {
                template_category: self.data.interviewCategory,
            };
            if (self.isPhoneInterview) {
                params.template_type = self.TEMPLATE_TYPES.PHONE;
            }
            self.allSmartFields = await InterviewV2API.getMessageTemplateSmartFields(params);
            self.videoInterivewSmartFields = self.allSmartFields.filter(field => field.code !== 'interview_location' && field.code !== 'interviewers_names');
            self.inPersonSmartFields = self.allSmartFields.filter(field => field.code !== 'video_interview_link' && field.code !== 'interviewers_names');
            self.loadingSmartFields = false;
            scope.$digest();
        }

        /**
         * Default interview email message
         */
        let defaultMessage = "";

        let setDefaultMessage = () => {
            if (self.interviewType === 'PHONE') {
                defaultMessage = $filter("translate")("Hello")
                    + " {candidate_first_name},\n\n"
                    + $filter("translate")("Congratulations") + "!"
                    + " {brand_name} "
                    + $filter("translate")("would like to invite you to an")
                    + ` ${VIEW_INFO[AMSAPI.PROCEED].title} ${$filter("translate")("for the")}`
                    + " {job_position} "
                    + $filter("translate")("position")
                    + ". "
                    + $filter("translate")("Schedule a time and date for your interview by clicking below")
                    + "."
                    + "\n\n{interview_link}\n";
            } else {
                if (self.data.interviewCategory === 'VIDEO_INTERVIEW') {
                    defaultMessage = `${$filter("translate")("Hello")} {candidate_first_name},\n\n${$filter("translate")("Congratulations")}! {brand_name} ${$filter("translate")("would like to invite you to a video interview for the")} {job_position} ${$filter("translate")("position")}. ${$filter("translate")("Schedule a time and date for your video interview by clicking below")}. ${$filter("translate")("At the time of your video interview click here to join")} {video_interview_link}.\n\n{interview_link}`;
                } else {
                    defaultMessage = `${$filter("translate")("Hello")} {candidate_first_name},\n\n${$filter("translate")("Congratulations")}! {brand_name} ${$filter("translate")("would like to invite you to an interview for the")} {job_position} ${$filter("translate")("position")}. ${$filter("translate")("Schedule a time and date for your interview by clicking below")}. ${ !self.isPhoneInterview ? `${$filter("translate")("Your interview will be held at")} {interview_location}.`: ""} \n\n{interview_link}`;
                }
            }
        };

        self.destroy = function () {
            self.interviewersList = [];
            self.messageTemplates = [];
            self.data.interviewers = [];
            self.data.locations = [];
            self.data.candidates = [];
            self.data.job = {};
            self.data.selected_candidates = {};
        };
    }

    angular
        .module('harriApp.interviewV2')
        .service('InterviewSettingsForm', [
            'hUser', 'InterviewDataService', '$modal', '$filter', 'brandServices', 'userPermissions', 'Upload',
            function (hUser, InterviewDataService, $modal, $filter, brandServices, userPermissions, Upload) {

                return function (scope, viewService, isManageAvailability, source) {
                    return new InterviewSettingsForm(scope, viewService, hUser, InterviewDataService, $modal, isManageAvailability, $filter, source, brandServices, userPermissions, Upload);
                }
            }]);
})();
